
// * ========================================================================
// * Sewage total chart
// * ========================================================================

import moment from 'moment';
import CovidChart from './covid-chart.js';

const sewageTotal = (function(){
    let thisChart = null;

    const average = (arr) => arr.reduce((a, b) => a + b) / arr.length;

    /**
     *
     * Create new chart
     *
     * @param {Object} data - covid data
     * @param {Object} options - chart options
     *
     * @returns {Object} - chart
     */
    function createChartData(data, options) {
        let datasets = [{
            label: 'Liukuva keskiarvo (vanhin)',
            id: 'average-oldest',
            type: 'line',
            fill: false,
            pointBorderWidth: 2,
            pointHoverBorderWidth: 2,
            borderColor: '#333333',
            borderWidth: 2,
            data: [],
            pointRadius: 5,
            pointHoverRadius: 8,
            cubicInterpolationMode: 'default',
            lineTension: 0.2,
            yAxisID: 'y'
        },
        {
            label: 'Koronavirusta jätevedessä (vanhin)',
            id: 'total-oldest',
            type: 'bubble',
            backgroundColor: '#666666',
            borderColor: '#333333',
            data: [],
            yAxisID: 'y',
            pointRadius: 5,
            hoverRadius: 2,
            borderWidth: 2,
            hoverBackgroundColor: '#333333'
        }, {
            label: 'Liukuva keskiarvo (vanha)',
            id: 'average-old',
            type: 'line',
            fill: false,
            borderColor: '#6d3a08',
            borderWidth: 2,
            pointBorderColor: '#6d3a08',
            pointBorderWidth: 2,
            pointHoverBorderWidth: 2,
            data: [],
            pointRadius: 5,
            pointHoverRadius: 8,
            cubicInterpolationMode: 'default',
            lineTension: 0.2,
            yAxisID: 'y'
        },
        {
            label: 'Koronavirusta jätevedessä (vanha)',
            id: 'total-old',
            type: 'bubble',
            backgroundColor: '#95571b',
            borderColor: '#6d3a08',
            data: [],
            yAxisID: 'y',
            pointRadius: 5,
            hoverRadius: 2,
            borderWidth: 2
        }, {
            label: 'Liukuva keskiarvo',
            id: 'average',
            type: 'line',
            fill: false,
            borderColor: '#e80a9a',
            borderWidth: 2,
            pointBorderColor: '#e80a9a',
            pointBorderWidth: 2,
            pointHoverBorderWidth: 2,
            data: [],
            pointRadius: 5,
            pointHoverRadius: 8,
            cubicInterpolationMode: 'default',
            lineTension: 0.2,
            yAxisID: 'y'
        },
        {
            label: 'Koronavirusta jätevedessä',
            id: 'total',
            type: 'bubble',
            backgroundColor: '#fa76cc',
            borderColor: '#e80a9a',
            data: [],
            yAxisID: 'y',
            pointRadius: 5,
            hoverRadius: 2,
            borderWidth: 2
        }];

        const newProcessingDate = moment('2023-01-01').set({
            hour: 0,
            minute: 0,
            second: 0
        });

        for (let idx = (data.weeks.length - 1); idx >= 0; idx--) {
            const item = data.weeks[idx];
            const date = moment(item.date);

            // Push only after first visible date
            if (date >= options.firstDate) {
                let firstDay = idx + 1;
                firstDay = firstDay > (data.weeks.length - 1) ? idx : firstDay;

                const pastWeekValues = [];
                const pastWeekValuesOld = [];
                const pastWeekValuesOldest = [];
                for (let x = idx; x <= firstDay; x++) {
                    if (data.weeks[x].weightedTotal !== null) {
                        if (moment(data.weeks[x].date) >= newProcessingDate) {
                            pastWeekValues.push(data.weeks[x].weightedTotal);
                        } else {
                            pastWeekValuesOld.push(data.weeks[x].weightedTotal);
                        }
                    }
                    if (data.weeks[x].weightedTotalOld !== null) {
                        pastWeekValuesOldest.push(data.weeks[x].weightedTotalOldEvened);
                    }
                }

                if (date >= newProcessingDate) {
                    let weeksAverage = pastWeekValues.length ? average(pastWeekValues) : 0;
                    weeksAverage = Math.round(weeksAverage);

                    // Add to average count
                    datasets[4].data.push({
                        x: date,
                        y: pastWeekValues.length && item.date !== '2022-06-20' ? weeksAverage : NaN
                    });

                    // Add to bubble
                    datasets[5].data.push({
                        x: date,
                        y: item.weightedTotal !== null && item.date !== '2022-06-20' ? item.weightedTotal : NaN
                    });
                } else {
                    let weeksAverageOld = pastWeekValuesOld.length ? average(pastWeekValuesOld) : 0;
                    weeksAverageOld = Math.round(weeksAverageOld);

                    // Add to average count
                    datasets[2].data.push({
                        x: date,
                        y: pastWeekValuesOld.length && item.date !== '2022-06-20' ? weeksAverageOld : NaN
                    });

                    // Add to bubble
                    datasets[3].data.push({
                        x: date,
                        y: item.weightedTotal !== null && item.date !== '2022-06-20' ? item.weightedTotal : NaN
                    });
                }

                let weeksAverageOldest = pastWeekValuesOldest.length ? average(pastWeekValuesOldest) : 0;
                weeksAverageOldest = Math.round(weeksAverageOldest);

                // Add to average count
                datasets[0].data.push({
                    x: date,
                    y: pastWeekValuesOldest.length && item.date !== '2022-07-04' && item.date !== '2022-06-27' ? weeksAverageOldest : NaN
                });

                // Add to bubble
                datasets[1].data.push({
                    x: date,
                    y: item.weightedTotalOldEvened !== null && item.date !== '2022-06-27' ? item.weightedTotalOldEvened : NaN/*,
                        r: 6*/
                });

            }
        }

        return { datasets };
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        const { datasets } = createChartData(data, window.config);

        thisChart = new CovidChart('sewage-total-chart', {
            type: 'line',
            datasets,
            chartOptions: {
                options: {
                    interaction: {
                        mode: 'x',
                        intersect: false
                    },
                    plugins: {
                        legend: {
                            display: true,
                        },
                        tooltip: {
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                            callbacks: {
                                label: function(tooltipItem) {
                                    let label = tooltipItem.dataset.label + ': ' || '';
                                    label = label + new Intl.NumberFormat('fi-FI').format(tooltipItem.raw.y);

                                    return label;
                                }
                            }
                        },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            stacked: true,
                            offset: true,
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M.YY',
                                }
                            }
                        },
                        y: {
                            display: false,
                            stacked: false,
                            type: 'linear',
                            position: 'right',
                            title: {
                                display: true,
                                text: 'Miljoonaa virus-RNA kopiota'
                            }
                        }/*,
                        y2: {
                            display: false,
                            stacked: false,
                            type: 'linear',
                            position: 'right',
                            title: {
                                display: false,
                                text: 'Miljoonaa virus-RNA kopiota / 1000 hlö / vrk (vanhin)'
                            }
                        },
                        y3: {
                            display: true,
                            stacked: false,
                            type: 'linear',
                            position: 'right',
                            title: {
                                display: true,
                                text: 'Miljoonaa virus-RNA kopiota / 1000 hlö / vrk (uusi)'
                            }
                        },*/
                    }
                }
            },
            config: window.config,
            responsive: ['aspectRatio','legend'],
            tooltips: {
                elementId: 'sewage-total-chart-tooltip',
                highlightFirstIndex: false,
                hideHighlight: false
            }
        });
    }

    function reload(data) {
        const { datasets } = createChartData(data, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default sewageTotal;
